import React from 'react';
import Button from './Button';

const SIZES = {
  sm: 'max-w-sm',
  md: 'max-w-lg',
  lg: 'max-w-2xl',
  xl: 'max-w-4xl',
  full: 'max-w-6xl',
};

export default function Modal({ open, onClose, title, children, size = 'md' }) {
  if (!open) return null;
  const sizeClass = SIZES[size] || SIZES.md;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30">
      {/* Overlay cliquable derrière le contenu */}
      <div className="fixed inset-0" onClick={onClose} />
      <div className={`bg-white rounded-2xl shadow-xl ${sizeClass} w-full max-h-[90vh] flex flex-col relative animate-fade-in mx-4`} onClick={e => e.stopPropagation()}>
        <Button
          className="absolute top-3 right-3 border border-blue-gray-200 text-blue-gray-400 bg-transparent rounded-full p-2 hover:bg-blue-50 focus:outline-none focus:ring-2 focus:ring-accent/30 z-10"
          onClick={onClose}
          aria-label="Fermer la modal"
          type="button"
          variant="secondary"
        >
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-5 h-5" strokeLinecap="round" strokeLinejoin="round">
            <line x1="6" y1="6" x2="18" y2="18" stroke="currentColor" />
            <line x1="6" y1="18" x2="18" y2="6" stroke="currentColor" />
          </svg>
        </Button>
        <div className="p-6 overflow-y-auto">
          {title && <h2 className="font-heading text-xl mb-4 text-left pr-8">{title}</h2>}
          <div>{children}</div>
        </div>
      </div>
    </div>
  );
}